import { useCallback } from "react"
import { useLazyQuery } from "@apollo/client"
import { TOKEN_USAGE } from "../graphql/queries"
import { useTokenStore } from "../Store/useTokenStore"

export function useTokenFetcher() {
  const setTokenData = useTokenStore((state) => state.setTokenData)

  const [fetchTokenUsage, { loading, error }] = useLazyQuery(TOKEN_USAGE, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data?.edShopifyTokenUsageSummary) {
        setTokenData(data.edShopifyTokenUsageSummary)
      }
    },
    onError: (err) => {
      console.error("Failed to refresh token usage:", err)
    },
  })

  const refreshTokens = useCallback((id) => {
    fetchTokenUsage({ variables: { where: { id } } })
  }, [fetchTokenUsage])

  return {
    refreshTokens,
    loading,
    error,
  }
}
